import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    total: 0,
    size: 0,
    page: 1,
    campaignList: [],
    loaderForButton: false,
    campaignLoading: false,
}

const campaignCardSlice = createSlice({
    name: "campaignCard",
    initialState,
    reducers: {
        setCampaignList(state, action) {
            state.campaignList = action?.payload?.pagination ? [...state.campaignList, ...action.payload?.campaignList] : action.payload?.campaignList
            state.page = action.payload.page || 0
            state.loaderForButton = action.payload.loaderForButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.campaignLoading = action.payload?.campaignLoading || false
            state.size = action.payload?.size
            state.total = action.payload?.total
        },
        setCampaignLoading(state, actions) {
            state.campaignLoading = actions.payload
        },
        setLoaderForButton(state, actions) {
            state.loaderForButton = actions.payload
        },
        defaultState(state, action) {
            return initialState
        },
        setCampaignStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
    }
})

export const campaignCardActions = campaignCardSlice.actions;
export default campaignCardSlice;